import { Avatar, Box, IconButton, Stack, Typography } from '@mui/material';
import React from 'react';
import Iconify from '../../components/Iconify';

export default function ChatHeader({ onClose }) {
  return (
    <Stack
      direction="row"
      height={85}
      width={1}
      bgcolor="primary.main"
      alignItems="center"
      justifyContent="space-between"
      px={2}
    >
      <Stack direction="row" spacing={2} alignItems="center">
        <Stack>
          <Box bgcolor="#FFF" borderRadius={10}>
            <Avatar alt="Remy Sharp" src="/logo/logo.png" />
          </Box>
        </Stack>
        <Stack>
          <Typography color="common.white" fontSize={16} fontWeight={600} lineHeight={1.2} letterSpacing={0}>
            Comment pouvons-nous vous aider ?
          </Typography>
          <Stack direction="row" alignItems="center" spacing={1}>
            <Box bgcolor="#16fb63" height={8} width={8} borderRadius={5} />
            <Typography fontSize={12} color="common.white">
              Choisissez un sujet
            </Typography>
          </Stack>
        </Stack>
      </Stack>
      <Stack>
        <IconButton onClick={onClose}>
          <Iconify icon="eva:close-fill" sx={{ color: 'white' }} />
        </IconButton>
      </Stack>
    </Stack>
  );
}
